import React, { useState } from "react";
import "../../styles/form.scss";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import StepProgress from "./StepProgress";
import AnimalInfo from "./steps/AnimalInfo";
import SpecialSituation from "./steps/SpecialSituation";
import GeneralCondition from "./steps/GeneralCondition";
import VitalValues from "./steps/VitalValues";
import DrinkAndEat from "./steps/DrinkAndEat";
import Excretions from "./steps/Excretions";
import SpecialCaseBirth from "./steps/SpecialCaseBirth";
import SpecialCaseHomeAnimals from "./steps/SpecialCaseHomeAnimals";
import SpecialCaseAccidents from "./steps/SpecialCaseAccidents";
import SpecialCaseIntoxication from "./steps/SpecialCaseIntoxication";
import SpecialCaseCrampAttack from "./steps/SpecialCaseCrampAttack";
import Result from "./steps/result";
import SpecialCaseForeignObject from "./steps/SpecialCaseForeignObject";
import { notificationService } from "../../services/Notifications/Notifications";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const StepForm = ({
  setUnsicher,
  scrollToIdElement,
  handleResultIndicator,
  handleSaveFormData,
  guideFormGeneralData,
}) => {
  const classes = useStyles();

  const [state, setState] = useState({
    step: 1,
    originStep: 1,
    points: {
      animalInfo: 0,
      generalCondition: 0,
      vitalValues: {
        bodyTemp: 0,
        glandColor: 0,
        breathFreq: 0,
      },
      drinkandeat: {
        drinking: 0,
        eating: 0,
      },
      excretions: {
        urine: 0,
        droppings: 0,
        vomiting: 0,
      },
    },
    infoMessage: "",
  });

  const [specialcases, setSpecialCases] = useState({
    birth: false,
    cramp: false,
    accident: false,
    foreignObject: false,
    homeAnimals: false,
    intoxications: false,
  });

  const [animalinfo, setAnimalinfo] = useState({
    animalname: "",
    age: "",
    species: "",
    sex: "",
    weight: null,
    castrated: false,
    preconditions: {
      heart: false,
      kidney: false,
      liver: false,
      epilepsia: false,
      cancer: false,
      other: "",
    },
    lastHeat: new Date(),
    pregnant: false,
    givingBirth: false,
    free: false,
    abroadLocation: "",
    wormcure: new Date(),
    vaccine: new Date(),
    rawFood: "",
  });

  const [specialsituations, setSpecialSituations] = useState("none");

  const [generalcondition, setGeneralCondition] = useState("none");

  // *** vitalvalues BodyTemp mapping
  // value[1] = '<37,0'
  // value[2] = '37-39,1'
  // value[3] = '39,1-39,6'
  // value[4] = '>39,6'

  // *** vitalvalues BreahtFreq mapping
  // value[1] = 'notMeasurable'
  // value[2] = '<30/min'
  // value[3] = '30-40/min'
  // value[4]= '>40/min'

  // *** drinkandeat drinking mapping ***

  // Behavior:
  // value[1] = Normal
  // value[2] = Mehr
  // value[3] = Weniger
  // value[4] = Überhaupt nicht

  // Since:
  // value[1] = Mehr als 6 Stunden
  // value[2] = Mehr als 12 Stunden
  // value[3] = Mehr als 24 Stunden

  // *** drinkandeat eating mapping

  // Behavior:
  // value[1] = Normal
  // value[2] = Mehr
  // value[3] = Weniger
  // value[4] = Überhaupt nicht

  // Since:
  // value[1] = Mehr als 6 Stunden
  // value[2] = Mehr als 12 Stunden
  // value[3] = Mehr als 24 Stunden

  // *** excretions mapping

  // URINE:
  // --- value[1] = Normal
  // --- value[2] = Weniger oder Mehr
  // --- value[3] = Häufiger aber nur wenig
  // --- value[4] = Kein

  // --- Since:
  // --- value[1] = Mehr als 6 Stunden
  // --- value[2] = Mehr als 12 Stunden
  // --- value[3] = Mehr als 24 Stunden

  // DROPPINGS:
  // --- value[1] = Normal
  // --- value[2] = Kein Kotabsatz
  // --- value[3] = breiig
  // --- value[4] = flüssig

  // --- Since:
  // --- value[1] = Mehr als 12 Stunden
  // --- value[2] = Mehr als 24 Stunden
  // --- value[3] = Mehr als 48 Stunden

  // VOMITING:
  // --- value[1] = Normal
  // --- value[2] = Gelegentlich
  // --- value[3] = ständig
  // --- value[4] = behält nichts bei sich

  // --- Since:
  // --- value[1] = Mehr als 12 Stunden
  // --- value[2] = Mehr als 24 Stunden
  // --- value[3] = Mehr als 48 Stunden

  const [vitalvalues, setVitalValues] = useState({
    bodyTemp: 0,
    glandColor: "nicht bestimmt",
    breathFreq: 0,
  });

  const [drinkandeat, setDrinkAndEat] = useState({
    drinking: {
      behavior: 1,
      since: 0,
    },
    eating: {
      behavior: 1,
      since: 0,
    },
  });

  const [excretions, setExcretions] = useState({
    urine: {
      behavior: 1,
      since: 0,
      bloody: false,
    },
    droppings: {
      behavior: 1,
      since: 0,
      bloody: false,
      black: false,
    },
    vomiting: {
      behavior: 1,
      since: 0,
      foamy: false,
      bile: false,
      bloody: false,
    },
  });

  const handleSpeciesChange = (species) => {
    setAnimalinfo({ ...animalinfo, species: species });
  };

  const handleGenderChange = (gender) => {
    setAnimalinfo({ ...animalinfo, sex: gender });
  };

  const handleInputChangeInfo = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setAnimalinfo({ ...animalinfo, [name]: value });
  };

  const handleDateChange = (selectedDate, datePickerName) => {
    setAnimalinfo({
      ...animalinfo,
      [datePickerName]: selectedDate,
    });
  };

  const handlePreconditions = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setAnimalinfo((animalinfo) => ({
      ...animalinfo,
      preconditions: {
        ...animalinfo.preconditions,
        [name]: value,
      },
    }));
  };

  const handleSpecialSituations = (event) => {
    setSpecialSituations(event.target.value);
  };

  const handleGeneralCondition = (event) => {
    setGeneralCondition(event.target.value);
  };

  const handleVitalvalueBodyTemp = (event, newValue) => {
    setVitalValues({ ...vitalvalues, bodyTemp: newValue });
  };

  const handleVitalvalueBreathFreq = (event, newValue) => {
    setVitalValues({ ...vitalvalues, breathFreq: newValue });
  };

  const handleVitalvalues = (event, newValue) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setVitalValues({ ...vitalvalues, [name]: value });
  };

  const handleDrinkAndEat = (event, valueType) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const type = valueType;

    if (type === "drinking") {
      setDrinkAndEat((drinkandeat) => ({
        ...drinkandeat,
        drinking: {
          ...drinkandeat.drinking,
          [name]: value,
        },
      }));
    }
    if (type === "eating") {
      setDrinkAndEat((drinkandeat) => ({
        ...drinkandeat,
        eating: {
          ...drinkandeat.eating,
          [name]: value,
        },
      }));
    }
  };

  const handleExcretions = (event, valueType) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    const type = valueType;

    if (type === "urine") {
      setExcretions((excretions) => ({
        ...excretions,
        urine: {
          ...excretions.urine,
          [name]: value,
        },
      }));
    }
    if (type === "droppings") {
      setExcretions((excretions) => ({
        ...excretions,
        droppings: {
          ...excretions.droppings,
          [name]: value,
        },
      }));
    }
    if (type === "vomiting") {
      setExcretions((excretions) => ({
        ...excretions,
        vomiting: {
          ...excretions.vomiting,
          [name]: value,
        },
      }));
    }
  };

  const continueToNextStep = (e) => {
    e.preventDefault();

    setState({ ...state, step: state.step + 1 });
  };

  const animalInfoNextStep = (e) => {
    e.preventDefault();
    if (animalinfo.age === "") {
      notificationService.error("Bitte wählen sie ein Alter für ihr Tier");
      return;
    }
    if (animalinfo.weight === null) {
      notificationService.error("Bitte setzen sie einen Gewicht für ihr Tier");
      return;
    }

    if (animalinfo.age === "Unter 1 Jahr") {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 1 },
      });
    }
    if (
      animalinfo.preconditions.heart ||
      animalinfo.preconditions.kidney ||
      animalinfo.preconditions.liver ||
      animalinfo.preconditions.epilepsia ||
      animalinfo.preconditions.cancer ||
      animalinfo.preconditions.other.length > 1
    ) {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 1 },
      });
    }
    if (animalinfo.age === "1 bis 5 Jahre" && animalinfo.preconditions.heart) {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 2 },
      });
    }
    if (animalinfo.age === "1 bis 5 Jahre" && animalinfo.preconditions.kidney) {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 2 },
      });
    }
    if (animalinfo.age === "1 bis 5 Jahre" && animalinfo.preconditions.liver) {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 2 },
      });
    }
    if (animalinfo.age === "1 bis 5 Jahre" && animalinfo.preconditions.epilepsia) {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 2 },
      });
    }
    if (animalinfo.age === "1 bis 5 Jahre" && animalinfo.preconditions.cancer) {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 2 },
      });
    }
    if (animalinfo.age === "1 bis 5 Jahre" && animalinfo.preconditions.other.length > 1) {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, animalInfo: state.points.animalInfo + 2 },
      });
    }

    if (animalinfo.givingBirth) {
      handleSaveFormData(animalinfo, vitalvalues, drinkandeat, excretions, generalcondition, {
        birth: true,
        cramp: false,
        accident: false,
        foreignObject: false,
        homeAnimals: false,
        intoxications: false,
      });
      setState({
        ...state,
        step: 7,
        originStep: state.step,
      });
    }
    if (animalinfo.species === "rabbit" || animalinfo.species === "ginnypig") {
      handleSaveFormData(animalinfo, vitalvalues, drinkandeat, excretions, generalcondition, {
        birth: false,
        cramp: false,
        accident: false,
        foreignObject: false,
        homeAnimals: true,
        intoxications: false,
      });
      setState({
        ...state,
        step: 8,
        originStep: state.step,
      });
    }

    if (
      animalinfo.age !== "Unter 1 Jahr" &&
      !animalinfo.givingBirth &&
      !animalinfo.preconditions.heart &&
      !animalinfo.preconditions.kidney &&
      !animalinfo.preconditions.liver &&
      !animalinfo.preconditions.epilepsia &&
      !animalinfo.preconditions.cancer &&
      animalinfo.preconditions.other.length < 1 &&
      (animalinfo.species !== "rabbit" || animalinfo.species !== "ginnypig")
    ) {
      handleSaveFormData(
        animalinfo,
        vitalvalues,
        drinkandeat,
        excretions,
        generalcondition,
        specialcases
      );
      setState({ ...state, step: state.step + 1 });
    }
  };

  // Go back to prev step and reset the points for that prev step
  const specialCaseprevStep = (e) => {
    e.preventDefault();

    setState({
      ...state,
      step: state.step - 1,
      points: { ...state.points, animalInfo: 0 },
    });
  };

  const specialCaseNextStep = (e) => {
    e.preventDefault();

    if (specialsituations === "trauma") {
      handleSaveFormData(animalinfo, vitalvalues, drinkandeat, excretions, generalcondition, {
        birth: false,
        cramp: false,
        accident: true,
        foreignObject: false,
        homeAnimals: false,
        intoxications: false,
      });
      setState({
        ...state,
        step: 9,
        originStep: state.step,
      });
    } else if (specialsituations === "cramp") {
      handleSaveFormData(animalinfo, vitalvalues, drinkandeat, excretions, generalcondition, {
        birth: false,
        cramp: true,
        accident: false,
        foreignObject: false,
        homeAnimals: false,
        intoxications: false,
      });
      setState({
        ...state,
        step: 11,
        originStep: state.step,
      });
    } else if (specialsituations === "poison" || specialsituations === "stomach") {
      handleSaveFormData(animalinfo, vitalvalues, drinkandeat, excretions, generalcondition, {
        birth: false,
        cramp: false,
        accident: false,
        foreignObject: false,
        homeAnimals: false,
        intoxications: true,
      });
      setState({
        ...state,
        step: 10,
        originStep: state.step,
      });
    } else if (specialsituations === "foreign") {
      handleSaveFormData(animalinfo, vitalvalues, drinkandeat, excretions, generalcondition, {
        birth: false,
        cramp: false,
        accident: false,
        foreignObject: true,
        homeAnimals: false,
        intoxications: false,
      });
      setState({
        ...state,
        step: 12,
        originStep: state.step,
      });
    } else {
      setState({ ...state, step: state.step + 1 });
    }
  };

  const generalConditionNextStep = (e) => {
    e.preventDefault();

    if (generalcondition === "noReaction") {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, generalCondition: state.points.generalCondition + 4 },
      });
    }
    if (generalcondition === "notWalking") {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, generalCondition: state.points.generalCondition + 3 },
      });
    }
    if (generalcondition === "irregularBehavior") {
      setState({
        ...state,
        step: state.step + 1,
        points: { ...state.points, generalCondition: state.points.generalCondition + 1 },
      });
    }
    if (generalcondition === "" || generalcondition === "notNoticeable") {
      setState({ ...state, step: state.step + 1 });
    }
    if (generalcondition === "none") {
      setState({ ...state, step: state.step + 1 });
    }
  };

  // Go back to prev step and reset the points for that prev step
  const vitalValuesprevStep = (e) => {
    e.preventDefault();

    setState({
      ...state,
      step: state.step - 1,
      points: { ...state.points, generalCondition: 0 },
    });
  };

  const calculateBodyTemp = () => {
    // *** BodyTemp Points *** //
    if (vitalvalues.bodyTemp === 1) {
      state.points.vitalValues.bodyTemp = +4;
    } else if (vitalvalues.bodyTemp === 3) {
      state.points.vitalValues.bodyTemp = +2;
    } else if (vitalvalues.bodyTemp === 4) {
      state.points.vitalValues.bodyTemp = +3;
    }
  };

  const calculateBreathFreq = () => {
    // *** BreathFreq Points *** //

    if (vitalvalues.breathFreq === 2) {
      // do nothing
    } else if (vitalvalues.breathFreq === 1) {
      state.points.vitalValues.breathFreq = +1;
    } else if (vitalvalues.breathFreq === 3) {
      state.points.vitalValues.breathFreq = +2;
    } else if (vitalvalues.breathFreq === 4) {
      state.points.vitalValues.breathFreq = +3;
    }
  };

  const calculateGlandColor = () => {
    // *** Gland Color Points *** //
    if (vitalvalues.glandColor === "Rosa") {
      // do nothing
    }

    if (vitalvalues.glandColor === "weakRosa" || vitalvalues.glandColor === "red") {
      state.points.vitalValues.glandColor = +1;
    }

    if (vitalvalues.glandColor === "blue" || vitalvalues.glandColor === "porcelainWhite") {
      state.points.vitalValues.glandColor = +3;
    }
  };

  const vitalValuesNextStep = async (e) => {
    e.preventDefault();

    if (
      vitalvalues.bodyTemp === "" ||
      vitalvalues.breathFreq === "" ||
      vitalvalues.glandColor === ""
    ) {
      setState({
        ...state,
        infoMessage: "Sie müssen alle felder ausfüllen um fortzufahren",
      });
    }

    try {
      calculateBodyTemp();
      calculateBreathFreq();
      calculateGlandColor();
    } catch (e) {
      console.log("couldn't calculate breathFreq");
    }

    setState({ ...state, step: state.step + 1 });
  };

  // Go back to prev step and reset the points for that prev step
  const drinkAndEatprevStep = (e) => {
    e.preventDefault();

    setState({
      ...state,
      step: state.step - 1,
      points: {
        ...state.points,
        vitalValues: {
          ...state.points.vitalValues,
          glandColor: 0,
          breathFreq: 0,
          bodyTemp: 0,
        },
      },
    });
  };

  const drinking = () => {
    if (drinkandeat.drinking.behavior === 1) {
      // do nothing
    } else if (
      (drinkandeat.drinking.behavior === 2 && drinkandeat.drinking.since === 3) ||
      (drinkandeat.drinking.behavior === 3 && drinkandeat.drinking.since === 3)
    ) {
      state.points.drinkandeat.drinking = +1;
    } else if (drinkandeat.drinking.behavior === 4 && drinkandeat.drinking.since === 1) {
      state.points.drinkandeat.drinking = +2;
    } else if (drinkandeat.drinking.since === 2) {
      state.points.drinkandeat.drinking = +3;
    } else if (drinkandeat.drinking.since === 3) {
      state.points.drinkandeat.drinking = +4;
    }
  };

  const eating = () => {
    if (drinkandeat.eating.behavior === 1) {
      // do nothing
    } else if (
      (drinkandeat.eating.behavior === 2 && drinkandeat.eating.since === 3) ||
      (drinkandeat.eating.behavior === 3 && drinkandeat.eating.since === 3)
    ) {
      state.points.drinkandeat.eating = +1;
    } else if (drinkandeat.eating.behavior === 4 && drinkandeat.eating.since === 1) {
      state.points.drinkandeat.eating = +1;
    } else if (drinkandeat.eating.since === 2) {
      state.points.drinkandeat.eating = +2;
    } else if (drinkandeat.eating.since === 3) {
      state.points.drinkandeat.eating = +3;
    }
  };

  const drinkAndEatNextStep = (e) => {
    e.preventDefault();

    try {
      drinking();
      eating();
    } catch (e) {
      console.log("couldn't calculate drinkandeat");
    }
    setState({ ...state, step: state.step + 1 });
  };

  // Go back to prev step and reset the points for that prev step
  const excretionsprevStep = (e) => {
    e.preventDefault();

    setState({
      ...state,
      step: state.step - 1,
      points: {
        ...state.points,
        drinkandeat: {
          ...state.points.drinkandeat,
          drinking: 0,
          eating: 0,
        },
      },
    });
  };

  const urinePointsCalculation = () => {
    try {
      if (excretions.urine.behavior === 1) {
        state.points.excretions.urine = 0;
      } else if (
        (excretions.urine.behavior === 2 && excretions.urine.since === 3) ||
        excretions.urine.behavior === 3
      ) {
        state.points.excretions.urine = +1;
      } else if (excretions.urine.behavior === 4 && excretions.urine.since === 1) {
        state.points.excretions.urine = +2;
      } else if (excretions.urine.since === 2) {
        state.points.excretions.urine = +3;
      } else if (excretions.urine.since === 3) {
        state.points.excretions.urine = +4;
      }
    } catch (e) {
      console.log("tried to add numbers to urine but failed");
    } finally {
      if (excretions.urine.bloody) {
        state.points.excretions.urine = state.points.excretions.urine + 1;
      }
    }
  };

  const droppingsPointsCalculation = () => {
    try {
      if (excretions.droppings.behavior === 1) {
        state.points.excretions.droppings = 0;
      } else if (excretions.droppings.behavior === 2 && excretions.droppings.since === 2) {
        state.points.excretions.droppings = +1;
      } else if (excretions.droppings.since === 2) {
        state.points.excretions.droppings = +1;
      } else if (excretions.droppings.since === 3) {
        state.points.excretions.droppings = +2;
      } else if (excretions.droppings.behavior === 3 && excretions.droppings.since === 3) {
        state.points.excretions.droppings = +1;
      } else if (excretions.droppings.behavior === 4 && excretions.droppings.since === 2) {
        state.points.excretions.droppings = +1;
      }
    } catch (e) {
      console.log("tried to add points to droppings but failed");
    } finally {
      if (excretions.droppings.bloody) {
        state.points.excretions.droppings = state.points.excretions.droppings + 1;
      }
      if (excretions.droppings.black) {
        state.points.excretions.droppings = state.points.excretions.droppings + 2;
      }
    }
  };

  const vomitingPointsCalculation = () => {
    try {
      if (excretions.vomiting.behavior === 1) {
        state.points.excretions.vomiting = 0;
      } else if (excretions.vomiting.behavior === 2 && excretions.vomiting.since === 2) {
        state.points.excretions.vomiting = 1;
      } else if (excretions.vomiting.since === 2) {
        state.points.excretions.vomiting = 2;
      } else if (excretions.vomiting.behavior === 2 && excretions.vomiting.since === 1) {
        state.points.excretions.vomiting = 1;
      } else if (excretions.vomiting.since === 2) {
        state.points.excretions.vomiting = 2;
      } else if (excretions.vomiting.since === 3) {
        state.points.excretions.vomiting = 3;
      } else if (excretions.vomiting.behavior === 4 && excretions.vomiting.since === 1) {
        state.points.excretions.vomiting = 2;
      } else if (excretions.vomiting.behavior === 4 && excretions.vomiting.since === 2) {
        state.points.excretions.vomiting = 3;
      } else if (excretions.vomiting.behavior === 4 && excretions.vomiting.since === 3) {
        state.points.excretions.vomiting = 4;
      }
    } catch (e) {
      console.log("tried to add points to vomiting but failed");
    } finally {
      if (excretions.vomiting.bloody || animalinfo.weight < 5) {
        state.points.excretions.vomiting = state.points.excretions.vomiting + 1;
      }
      if (excretions.vomiting.bloody && animalinfo.weight < 5) {
        state.points.excretions.vomiting = state.points.excretions.vomiting + 1;
      }
    }
  };

  const excretionsNextStep = (e) => {
    e.preventDefault();

    try {
      urinePointsCalculation();
      droppingsPointsCalculation();
      vomitingPointsCalculation();
    } catch (e) {
      console.log("couldn't calculate excretions");
    } finally {
      handleSaveFormData(
        animalinfo,
        vitalvalues,
        drinkandeat,
        excretions,
        generalcondition,
        specialcases
      );
      setState({ ...state, step: 13 });
    }
  };

  // Go back to prev step and reset the points for that prev step
  const resultprevStep = (e) => {
    e.preventDefault();

    setState({
      ...state,
      step: 6,
      points: {
        ...state.points,
        excretions: {
          ...state.points.excretions,
          urine: 0,
          droppings: 0,
          vomiting: 0,
        },
      },
    });
  };

  // Go back to prev step
  const extremeCaseprevStep = (e) => {
    e.preventDefault();
    setState({
      ...state,
      step: state.originStep,
    });
  };

  // Proceed to next step
  const nextStep = (e) => {
    setState({
      ...state,
      step: state.step + 1,
    });
  };

  // Go back to prev step
  const prevStep = (e) => {
    e.preventDefault();

    setState({
      ...state,
      step: state.step - 1,
    });
  };

  const handleStep = (step) => {
    setState({
      ...state,
      step: step + 1,
    });
  };

  const handleValues = (event) => {
    const { name, value } = event.target;
    setAnimalinfo({ ...animalinfo, [name]: value });
  };

  const formElements = () => {
    switch (state.step) {
      case 1:
        return (
          <>
            <div>
              <div className="formHeader">
                <p>{guideFormGeneralData.infoTitle}</p>

                <div className="ratgeber__grid">
                  <span>{guideFormGeneralData.infoLabel1}</span>
                  <span>{guideFormGeneralData.infoLabel2}</span>
                  <span>{guideFormGeneralData.infoLabel3}</span>
                  <span>{guideFormGeneralData.infoLabel4}</span>
                </div>
              </div>
              <AnimalInfo
                animalinfo={animalinfo}
                preconditions={animalinfo.preconditions}
                handleValues={handleValues}
                handleInputChangeInfo={handleInputChangeInfo}
                handleSpeciesChange={handleSpeciesChange}
                handleGenderChange={handleGenderChange}
                handlePreconditions={handlePreconditions}
                handleDateChange={handleDateChange}
              />
            </div>
            <div className="button--grid">
              <div />
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={animalInfoNextStep}
                className="button--next"
              >
                Weiter
              </Button>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <div>
              <SpecialSituation
                specialsituations={specialsituations}
                animalinfo={animalinfo}
                handleValues={handleValues}
                handleInputChangeInfo={handleInputChangeInfo}
                handleSpecialSituations={handleSpecialSituations}
              />
            </div>
            <div className="button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={specialCaseprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={specialCaseNextStep}
                className="button--next"
              >
                Weiter
              </Button>
            </div>
          </>
        );
      case 3:
        return (
          <>
            <div>
              <GeneralCondition
                generalcondition={generalcondition}
                animalinfo={animalinfo}
                handleValues={handleValues}
                handleInputChangeInfo={handleInputChangeInfo}
                handleGeneralCondition={handleGeneralCondition}
              />
            </div>
            <div className="button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={prevStep}
                className="button--prev"
              >
                Zurück
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={generalConditionNextStep}
                className="button--next"
              >
                Weiter
              </Button>
            </div>
          </>
        );
      case 4:
        return (
          <>
            <div>
              <VitalValues
                vitalvalues={vitalvalues}
                animalinfo={animalinfo}
                handleValues={handleValues}
                handleInputChangeInfo={handleInputChangeInfo}
                handleVitalvalues={handleVitalvalues}
                handleVitalvalueBodyTemp={handleVitalvalueBodyTemp}
                handleVitalvalueBreathFreq={handleVitalvalueBreathFreq}
              />
            </div>
            <div className="button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={vitalValuesprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={vitalValuesNextStep}
                className="button--next"
              >
                Weiter
              </Button>
            </div>
          </>
        );
      case 5:
        return (
          <>
            <div>
              <DrinkAndEat drinkandeat={drinkandeat} handleDrinkAndEat={handleDrinkAndEat} />
            </div>
            <div className="button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={drinkAndEatprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={drinkAndEatNextStep}
                className="button--next"
              >
                Weiter
              </Button>
            </div>
          </>
        );
      case 6:
        return (
          <>
            <div>
              <Excretions excretions={excretions} handleExcretions={handleExcretions} />
            </div>
            <div className="button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={excretionsprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={excretionsNextStep}
                className="button--next"
              >
                Ergebnis
              </Button>
            </div>
          </>
        );
      case 7:
        return (
          <>
            <div className="specialcase--wrapper">
              <h1>Spezialfall: Tier in der Geburt</h1>
              <SpecialCaseBirth />
            </div>
            <div className="button--grid result--button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={extremeCaseprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
            </div>
          </>
        );
      case 8:
        return (
          <>
            <div className="specialcase--wrapper">
              <SpecialCaseHomeAnimals />
            </div>
            <div className="button--grid result--button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={extremeCaseprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
            </div>
          </>
        );
      case 9:
        return (
          <>
            <div className="specialcase--wrapper">
              <SpecialCaseAccidents
                animalinfo={animalinfo}
                setUnsicher={setUnsicher}
                scrollToIdElement={scrollToIdElement}
              />
            </div>
            <div className="button--grid result--button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={extremeCaseprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
            </div>
          </>
        );
      case 10:
        return (
          <>
            <div className="specialcase--wrapper">
              <SpecialCaseIntoxication />
            </div>
            <div className="button--grid result--button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={extremeCaseprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
            </div>
          </>
        );
      case 11:
        return (
          <>
            <div className="specialcase--wrapper">
              <SpecialCaseCrampAttack />
            </div>
            <div className="button--grid result--button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={extremeCaseprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
            </div>
          </>
        );
      case 12:
        return (
          <>
            <div className="specialcase--wrapper">
              <SpecialCaseForeignObject />
            </div>
            <div className="button--grid result--button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={extremeCaseprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
            </div>
          </>
        );
      case 13:
        let animalInfoPoints = state.points.animalInfo;
        let generalConditionPoints = state.points.generalCondition;
        let bodyTempPoints = state.points.vitalValues.bodyTemp;
        let glandColorPoints = state.points.vitalValues.glandColor;
        let breathFreqPoints = state.points.vitalValues.breathFreq;
        let drinkingPoints = state.points.drinkandeat.drinking;
        let eatingPoints = state.points.drinkandeat.eating;
        let urinePoints = state.points.excretions.urine;
        let droppingsPoints = state.points.excretions.droppings;
        let vomitingPoints = state.points.excretions.vomiting;

        const result =
          animalInfoPoints +
          generalConditionPoints +
          bodyTempPoints +
          glandColorPoints +
          breathFreqPoints +
          drinkingPoints +
          eatingPoints +
          urinePoints +
          droppingsPoints +
          vomitingPoints;

        // return result

        return (
          <>
            <div>
              <Result
                state={state}
                result={result}
                setUnsicher={setUnsicher}
                scrollToIdElement={scrollToIdElement}
                handleResultIndicator={handleResultIndicator}
              />
            </div>
            <div className="button--grid result--button--grid">
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={resultprevStep}
                className="button--prev"
              >
                Zurück
              </Button>
            </div>
          </>
        );

      default:
        console.log("Something went wrong. whoops.");
    }
  };

  return (
    <>
      <form noValidate autoComplete="off">
        {state.step > 1 && state.step < 7 ? (
          <StepProgress activeStep={state.step} handleStep={handleStep} />
        ) : (
          <div className="stepper--placeholder" />
        )}

        {formElements()}
      </form>
      <p>{state.infoMessage}</p>
    </>
  );
};

export default StepForm;
